// @flow

import React, {Component} from 'react';
import ReactDOM from 'react-dom';
import { connect } from 'react-redux';

import {signUp, signUpData} from '../../actions';

import { RegisterProps, RegisterState } from "../../TypeDefinitions";

import TextField from 'material-ui/TextField';
import RaisedButton from 'material-ui/RaisedButton';

import muiThemeable from "material-ui/styles/muiThemeable";
import {validateField, validateForm} from "../../../../services/validate";

import { FormattedMessage } from 'react-intl';

class Register extends Component <RegisterProps, RegisterState> {

    state = {
        values: {
            first_name: '',
            last_name: '',
            email: '',
            email_confirm: '',
            password: '',
            password_confirm: '',
        },
        errors: {
            first_name: null,
            last_name: null,
            email: null,
            email_confirm: null,
            password: null,
            password_confirm: null,
        },
        rules: {
            first_name: {
                required: 'First name is required'
            },
            last_name: {
                required: 'Last name is required'
            },
            email: {
                required: 'Email is required',
                isEmail: 'Email is not valid'
            },
            email_confirm: {
                required: 'Email confirmation is required',
                equals: 'Email doesn\'t match'
            },
            password: {
                required: 'Password is required',
                validPassword: 'Password should have more than 7 characters'
            },
            password_confirm: {
                required: 'Password confirmation is required',
                equals: 'Password doesn\'t match'
            }
        }
    };

    componentDidMount() {
        // // Direct reference to email DOM node
        // const emailNode = ReactDOM.findDOMNode(this.refs.email);
        // // Evergreen event listener || IE8 event listener
        // const addEmailEvent = emailNode.addEventListener || emailNode.attachEvent;
        // addEmailEvent('copy', this.handleKeyPress, false);
        // addEmailEvent('cut', this.handleKeyPress, false);

        // // Direct reference to email DOM node
        // const emailConfirmNode = ReactDOM.findDOMNode(this.refs.email_confirm);
        // // Evergreen event listener || IE8 event listener
        // const addEmailConfirmEvent = emailConfirmNode.addEventListener || emailConfirmNode.attachEvent;
        // addEmailConfirmEvent('paste', this.handleKeyPress, false);

    }

    handleKeyPress(event) {
        event.preventDefault();
    }

    updateField = (e, value) => {
        const name = e.target.name;

        const rules = this.state.rules[name];

        let value2 = null;

        if (name === "email_confirm")
            value2 = this.state.values.email;

        if (name === "password_confirm")
            value2 = this.state.values.password;

        let is_valid = validateField(name, rules, value, value2);

        this.setState(prevState => ({
            values: {...prevState.values, [name]: value},
            errors: {...prevState.errors, [name]: is_valid}
        }));
    };

    registerAction = (e) => {
        e.preventDefault();

        if (!validateForm(this.state.errors)) return false;

        const { email, password, first_name, last_name } = this.state.values;

        if (email && password) {
            this.props.register(email, password, first_name, last_name);
        }
    };


    render() {
        return (
            <div>
                <TextField
                    name="first_name"
                    ref="first_name"
                    id="personal_first_name"
                    style={this.props.muiTheme.personal.textField}
                    defaultValue={this.state.values.first_name}
                    hintText={
                        <FormattedMessage
                            id="checkout.firstName"
                            defaultMessage="First name"
                        />
                    }
                    errorText={this.state.errors.first_name}
                    onChange={this.updateField}
                />
                <TextField
                    name="last_name"
                    ref="last_name"
                    id="personal_last_name"
                    style={this.props.muiTheme.personal.textField}
                    defaultValue={this.state.values.last_name}
                    hintText={
                        <FormattedMessage
                            id="checkout.lastName"
                            defaultMessage="Last name"
                        />
                    }
                    errorText={this.state.errors.last_name}
                    onChange={this.updateField}
                />
                <TextField
                    name="email"
                    ref="email"
                    id="personal_email"
                    style={this.props.muiTheme.personal.textField}
                    defaultValue={this.state.values.email}
                    hintText={
                        <FormattedMessage
                            id="checkout.email"
                            defaultMessage="Email"
                        />
                    }
                    type="email"
                    errorText={this.state.errors.email}
                    onChange={this.updateField}
                />
                <TextField
                    name="email_confirm"
                    ref="email_confirm"
                    id="personal_email_confirm"
                    style={this.props.muiTheme.personal.textField}
                    defaultValue={this.state.values.email_confirm}
                    hintText={
                        <FormattedMessage
                            id="checkout.emailConfirm"
                            defaultMessage="Email confirm"
                        />
                    }
                    type="email"
                    errorText={this.state.errors.email_confirm}
                    onChange={this.updateField}
                />
                <TextField
                    name="password"
                    ref="password"
                    id="personal_password"
                    style={this.props.muiTheme.personal.textField}
                    defaultValue={this.state.values.password}
                    hintText={
                        <FormattedMessage
                            id="checkout.password"
                            defaultMessage="Password"
                        />
                    }
                    type="password"
                    errorText={this.state.errors.password}
                    onChange={this.updateField}
                />
                <TextField
                    name="password_confirm"
                    ref="password_confirm"
                    id="personal_password_confirm"
                    style={this.props.muiTheme.personal.textField}
                    defaultValue={this.state.values.password_confirm}
                    hintText={
                        <FormattedMessage
                            id="checkout.passwordConfirm"
                            defaultMessage="Password confirm"
                        />
                    }
                    type="password"
                    errorText={this.state.errors.password_confirm}
                    onChange={this.updateField}
                />
                <RaisedButton
                    label={
                        <FormattedMessage
                            id="checkout.signup"
                            defaultMessage="Signup"
                        />
                    }
                    className="loginBtn-2"
                    primary={true}
                    style={this.props.muiTheme.personal.buttons.yes}
                    onClick={this.registerAction}
                    secondary={true}
                />
            </div>
        )
    }
}

const mapDispatchToProps = (dispatch) => ({
    register: (email, password, first_name, last_name) => {
        dispatch(signUp({email, password, connection: process.env.REACT_APP_AUTH0_CONNECTION, user_metadata: {first_name: first_name, last_name: last_name}}));
        dispatch(signUpData({email, first_name, last_name}))
    }
});

export default muiThemeable()(connect(() => ({}), mapDispatchToProps)(Register));
